import { PMLineChartCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import {
  getCompletedItemsDataAndCategories,
  TIMEFRAME_OPTIONS,
} from "../../../utils/getCompletedItemsByTimeframe";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addCompletedCumulativeItemsOverTimeCard(
  ctx: DashboardCardContext
) {
  const { view, language, getCardCopy } = ctx;

  const completedCumulativeItemsOverTimeComponent = view.addComponent({
    component: PMLineChartCard,
    layoutProps: {
      componentId: "completedCumulativeItemsOverTimeComponent",
      title: "",
      description: "",
      labels: ["lineChart", "chart", "accumulatedCompletedItemsOverTime"],
    },
  });

  completedCumulativeItemsOverTimeComponent.mapLayoutProps(() => {
    return {
      componentId: "completedCumulativeItemsOverTimeComponent",
      labels: ["lineChart", "chart", "accumulatedCompletedItemsOverTime"],
      title: getCardCopy(language, "completedItemsOverTimeCumulative").title,
      description: getCardCopy(language, "completedItemsOverTimeCumulative")
        .description,
    };
  });

  completedCumulativeItemsOverTimeComponent.mapState((appState) => {
    const accumulatedCompletedItemsOverReportingCycle =
      appState?.dashboard?._calculated
        ?.accumulatedCompletedItemsOverReportingCycle;
    const language = appState?.language;
    const { data, categories } = getCompletedItemsDataAndCategories(
      accumulatedCompletedItemsOverReportingCycle
    );

    return {
      title: getCardCopy(language, "completedItemsOverTimeCumulative").title,
      timespans: TIMEFRAME_OPTIONS,

      data,
      categories,
      xLabel: getLocalizedMessage(language, "time") || "Time",
      yLabel:
        getLocalizedMessage(language, "completedItems") || "Completed Items",
    };
  });

  completedCumulativeItemsOverTimeComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
